import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = { class: "p-grid custom-header" }
const _hoisted_5 = { class: "p-col-fixed header p-as-center" }
const _hoisted_6 = {
  key: 0,
  class: "p-col p-d-flex p-jc-center"
}
const _hoisted_7 = {
  key: 0,
  class: "p-col-fixed"
}
const _hoisted_8 = {
  key: 1,
  class: "p-col-fixed"
}
const _hoisted_9 = {
  key: 2,
  class: "p-col-fixed"
}
const _hoisted_10 = {
  key: 3,
  class: "p-col-fixed"
}
const _hoisted_11 = {
  key: 1,
  class: "p-col-fixed p-text-right p-as-center"
}
const _hoisted_12 = { class: "p-grid" }
const _hoisted_13 = { class: "p-col" }
const _hoisted_14 = { class: "p-col" }
const _hoisted_15 = {
  key: 0,
  class: "indicator pi pi-arrow-down"
}
const _hoisted_16 = {
  key: 1,
  class: "indicator pi pi-arrow-up"
}
const _hoisted_17 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass([
                                              'title p-col-3 p-text-right'
                                          ])
}
const _hoisted_18 = { class: "p-grid" }
const _hoisted_19 = { class: "p-col-12" }
const _hoisted_20 = { class: "p-grid" }
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = { class: "p-col-12" }
const _hoisted_24 = { class: "p-col-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-2 aux" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 custom-line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" })
  ])
], -1)
const _hoisted_26 = { class: "p-col-9" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Email enviado ")
const _hoisted_28 = { class: "p-col-12" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-2 aux" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 custom-line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" })
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-9" }, " WarmUp ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "p-col p-text-right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_spam = _resolveComponent("spam")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tracingData, (info) => {
      return (_openBlock(), _createElementBlock("div", {
        key: info,
        class: "p-col-12 p-pr-6 p-pl-6 p-pb-2"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(info.levelInfo? info.levelInfo.title : '--'), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Accordion, null, {
              default: _withCtx(() => [
                _createVNode(_component_AccordionTab, null, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, " Comisión " + _toDisplayString(info.camadaInfo? info.camadaInfo.id : '--'), 1),
                      (info.tracingTags !== undefined && _ctx.isReinfo === `true`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (info.tracingTags.neutral.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_component_Tag, {
                                    style: {"color":"black"},
                                    class: _normalizeClass(['p-tag-yellow-brain'])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.tracingTags.neutral[0].value), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true),
                            (info.tracingTags.neutral.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_Tag, {
                                    style: {"color":"black"},
                                    class: _normalizeClass(['p-tag-yellow-brain'])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.tracingTags.neutral[0].title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true),
                            (info.tracingTags.negative.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_component_Tag, {
                                    style: {"color":"black"},
                                    class: _normalizeClass(['p-tag-red-brain'])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.tracingTags.negative[0].value), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true),
                            (info.tracingTags.negative.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(_component_Tag, {
                                    style: {"color":"black"},
                                    class: _normalizeClass(['p-tag-red-brain'])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info.tracingTags.negative[0].title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (info.rating[0] !== undefined || null && _ctx.isReinfo === `true`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                                          'p-col',
                                          info.rating[0].value >= 4.7 ? 'positive-rate' : 'negative-rate'
                                          ])
                              }, _toDisplayString(info.rating[0].value), 3),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(info.rating[0].variation), 1),
                              _createElementVNode("div", _hoisted_14, [
                                (info.rating[0].variation < 0)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                  : (info.rating[0].variation > 0)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_17))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatDate(info.assignationDate)), 1),
                              _createElementVNode("div", _hoisted_24, _toDisplayString(info.tracingStage), 1),
                              _hoisted_25,
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_spam, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(info.updatedAt) ?? '--'), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_27
                              ]),
                              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDate(_ctx.getWarmupDate(info.camadaInfo.complementarySchedules)) ?? '--'), 1),
                              _hoisted_29,
                              _hoisted_30
                            ])
                          ]),
                          _hoisted_31
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]))
    }), 128))
  ]))
}